<div class="md:pt-3 pt-2 md:px-4 px-3 pb-8 mb-4">
  <h1 class="text-base md:text-lg text-900 flex align-items-center mb-0 line-height-1">
    {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.TITLE' | translate }}
  </h1>
  <div class="mt-1 mb-3">
    <app-breadcrumb />
  </div>

  <!-- Card Tab Header -->
  <ul class="list-none mt-3 mb-0 p-0 flex overflow-x-auto text-sm text-700 white-space-nowrap">
    <li
      [ngClass]="{'font-bold border-primary text-900': activeTabIndex === 0, 'border-white': activeTabIndex !== 0}"
      (click)="onTabChange({index: 0})"
      class="p-3 md:p-4 md:px-5 border-bottom-3 cursor-pointer"
      aria-label="process-tab">
      {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.PROCESS_TAB' | translate }}
    </li>
    <li
      [ngClass]="{'font-bold border-primary text-900': activeTabIndex === 1, 'border-white': activeTabIndex !== 1}"
      (click)="onTabChange({index: 1})"
      class="p-3 md:p-4 md:px-5 border-bottom-3 cursor-pointer"
      aria-label="processed-tab">
      {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.PROCESSED_TAB' | translate }}
    </li>
  </ul>
  <!-- Card Tab Header -->

  <div class="surface-0 shadow-2 border-round">
    <div class="px-2 md:px-3 pt-3">
        
        <!-- Filter Section -->
        <div class="mb-3">
          <div class="flex justify-content-between align-items-center mb-2">
            <h3 class="text-900 font-semibold m-0">
              {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.FILTERS' | translate }}
            </h3>
          </div>

          <div class="surface-50 border-round p-3">
            <div class="grid">
              <!-- Date From -->
              <div class="col-12 md:col-3">
                <label for="date-from" class="block text-900 font-medium mb-2">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.DATE_FROM' | translate }}
                </label>
                <p-datepicker id="date-from"
                  [(ngModel)]="dateFrom"
                  [showIcon]="true"
                  [showButtonBar]="true"
                  dateFormat="yy-mm-dd"
                  [placeholder]="'COMMISSION_MANAGEMENT.TRANSACTIONS.SELECT_DATE' | translate"
                  styleClass="w-full"
                  aria-label="date-from-filter" />
              </div>

              <!-- Date To -->
              <div class="col-12 md:col-3">
                <label for="date-to" class="block text-900 font-medium mb-2">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.DATE_TO' | translate }}
                </label>
                <p-datepicker id="date-to"
                  [(ngModel)]="dateTo"
                  [showIcon]="true"
                  [showButtonBar]="true"
                  dateFormat="yy-mm-dd"
                  [placeholder]="'COMMISSION_MANAGEMENT.TRANSACTIONS.SELECT_DATE' | translate"
                  styleClass="w-full"
                  aria-label="date-to-filter" />
              </div>

              <!-- Staff Filter -->
              <div class="col-12 md:col-3">
                <label class="block text-900 font-medium mb-2">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.STAFF' | translate }}
                </label>
                <multi-select-staff [selected]="selectedStaffIds"
                  [placeholder]="'COMMISSION_MANAGEMENT.TRANSACTIONS.SELECT_STAFF_PLACEHOLDER' | translate"
                  (selectStaffEvent)="onStaffFilterChanged($event)" />
              </div>

              <!-- Plan Filter -->
              <div class="col-12 md:col-3">
                <label for="plan-filter" class="block text-900 font-medium mb-2">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.PLANS' | translate }}
                </label>
                <p-multiSelect id="plan-filter"
                  [(ngModel)]="selectedPlanIds"
                  [options]="commissionPlans"
                  optionLabel="name_pri_lang"
                  optionValue="id"
                  [placeholder]="'COMMISSION_MANAGEMENT.TRANSACTIONS.SELECT_PLANS' | translate"
                  [filter]="true"
                  [showClear]="true"
                  styleClass="w-full"
                  aria-label="plan-filter" />
              </div>
            </div>

            <!-- Filter Actions -->
            <div class="flex flex-wrap gap-2 mt-3">
              <p-button [label]="'COMMISSION_MANAGEMENT.COMMON.APPLY_FILTERS' | translate"
                icon="pi pi-check"
                size="small"
                styleClass="white-space-nowrap"
                (onClick)="applyFilters()"
                aria-label="apply-filters-button" />
              <p-button [label]="'COMMISSION_MANAGEMENT.COMMON.CLEAR_FILTERS' | translate"
                icon="pi pi-times"
                [outlined]="true"
                severity="secondary"
                size="small"
                styleClass="white-space-nowrap"
                (onClick)="clearFilters()"
                aria-label="clear-filters-button" />
            </div>
          </div>
        </div>

        <!-- Process Tab Content -->
        @if (activeTabIndex === 0) {
          <div>
          <div class="flex flex-column md:flex-row justify-content-between md:align-items-center gap-3 mb-3 mt-3">
            <div>
              <p class="text-500 mt-0 mb-0">
                {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.PROCESS_SUBTITLE' | translate }}
              </p>
            </div>
            <div class="flex flex-wrap gap-2">
              <p-button [label]="'COMMISSION_MANAGEMENT.TRANSACTIONS.STAFF_ADJUSTMENT' | translate"
                icon="pi pi-check"
                severity="success"
                size="small"
                styleClass="white-space-nowrap"
                (onClick)="openStaffAdjustmentDialog()"
                aria-label="staff-adjustment-button" />
              <p-button [label]="'COMMISSION_MANAGEMENT.TRANSACTIONS.PROCESS_SELECTED' | translate: {count: totalSelectedTransactions}"
                icon="pi pi-check-circle"
                severity="info"
                size="small"
                styleClass="white-space-nowrap"
                [disabled]="totalSelectedTransactions === 0"
                [pTooltip]="totalSelectedTransactions === 0 ? ('COMMISSION_MANAGEMENT.TRANSACTIONS.SELECT_TRANSACTIONS_TO_PROCESS' | translate) : ''"
                tooltipPosition="top"
                (onClick)="openBulkTransactionProcessDialog()"
                aria-label="bulk-transaction-process-button" />
              <p-button [label]="'COMMISSION_MANAGEMENT.TRANSACTIONS.EXPAND_ALL' | translate"
                icon="pi pi-plus"
                [text]="true"
                size="small"
                styleClass="white-space-nowrap"
                (onClick)="expandAll()"
                aria-label="expand-all-rows-button" />
              <p-button [label]="'COMMISSION_MANAGEMENT.TRANSACTIONS.COLLAPSE_ALL' | translate"
                icon="pi pi-minus"
                [text]="true"
                size="small"
                styleClass="white-space-nowrap"
                (onClick)="collapseAll()"
                aria-label="collapse-all-rows-button" />
            </div>
          </div>

          <!-- Staff Table with Row Expansion -->
          <div class="overflow-x-auto">
            <p-table
              [value]="processStaffList"
              [loading]="loading"
              [(selection)]="selectedStaff"
              [paginator]="true"
              [rows]="pageSize"
              [totalRecords]="totalRecords"
              [lazy]="true"
              (onPage)="onPageChange($event)"
              [rowsPerPageOptions]="[10, 25, 50]"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="{first} - {last} of {totalRecords}"
              dataKey="staffId"
              [expandedRowKeys]="expandedRows"
              (onRowExpand)="onRowExpand($event)"
              (onRowCollapse)="onRowCollapse($event)"
              styleClass="p-datatable-gridlines"
              [tableStyle]="{ 'min-width': '60rem' }"
              [responsiveLayout]="'scroll'"
              aria-label="process-transactions-table">
            
            <ng-template #header>
              <tr>
                <th style="width: 3rem" aria-label="expand-column"></th>
                <th style="width: 3rem" aria-label="selection-column">
                  <p-checkbox [binary]="true"
                    [ngModel]="areAllStaffSelected()"
                    (ngModelChange)="onSelectAllStaff($event)"
                    aria-label="select-all-staff-checkbox" />
                </th>
                <th aria-label="staff-name-column">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.STAFF_NAME' | translate }}
                </th>
                <th aria-label="staff-email-column">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.EMAIL' | translate }}
                </th>
                <th aria-label="staff-mobile-column">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.MOBILE' | translate }}
                </th>
                <th aria-label="transaction-type-column">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.TYPE' | translate }}
                </th>
                <th aria-label="aggregated-amount-column">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.AMOUNT' | translate }}
                </th>
                <th aria-label="transactions-count-column">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.TRANSACTIONS_COUNT' | translate }}
                </th>
              </tr>
            </ng-template>

            <ng-template #body let-staff let-expanded="expanded">
              <tr>
                <td>
                  <p-button type="button"
                    [pRowToggler]="staff"
                    [text]="true"
                    [rounded]="true"
                    [plain]="true"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    [attr.aria-label]="'expand-row-' + staff.staff_id" />
                </td>
                <td>
                  <p-checkbox [binary]="true"
                    [ngModel]="isStaffSelected(staff)"
                    (ngModelChange)="onStaffSelect(staff, $event)"
                    [attr.aria-label]="'select-staff-' + staff.staff_id" />
                </td>
                <td>
                  <span class="font-semibold">{{ staff.staff_name }}</span>
                </td>
                <td>{{ staff.staff_email_id }}</td>
                <td>{{ staff.staff_mobile }}</td>
                <td>
                  <p-tag [value]="staff.type"
                    [severity]="getTransactionTypeSeverity(staff.type)"
                    [attr.aria-label]="'transaction-type-' + staff.type" />
                </td>
                <td>
                  <span class="font-semibold">{{ staff.aggregated_amount | currencyformat }}</span>
                </td>
                <td>
                  <p-tag [value]="getTransactionsCount(staff)"
                    severity="info"
                    [attr.aria-label]="'transactions-count-' + staff.staff_id" />
                </td>
              </tr>
            </ng-template>

            <!-- Row Expansion Template -->
            <ng-template #expandedrow let-staff>
              <tr>
                <td colspan="8">
                  <div class="pl-7 pr-3 py-2 surface-50">
                    @if (hasTransactions(staff)) {
                      <div>
                      <!-- Transactions Table -->
                      <p-table
                        [value]="staff.transactions"
                        styleClass="p-datatable-sm p-datatable-striped"
                        [tableStyle]="{ 'min-width': '50rem' }"
                        aria-label="staff-transactions-table">
                        <ng-template pTemplate="header">
                          <tr>
                            <th style="width: 3rem" aria-label="transaction-select-column">
                              <p-checkbox [binary]="true"
                                [ngModel]="areAllTransactionsSelected(staff)"
                                (ngModelChange)="onSelectAllTransactions(staff, $event)"
                                [attr.aria-label]="'select-all-transactions-' + staff.staff_id" />
                            </th>
                            <th aria-label="transaction-date-column">
                              {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.DATE' | translate }}
                            </th>
                            <th aria-label="transaction-plan-column">
                              {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.PLAN' | translate }}
                            </th>
                            <th aria-label="transaction-slab-column">
                              {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.SLAB' | translate }}
                            </th>
                            <th aria-label="transaction-type-column">
                              {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.TYPE' | translate }}
                            </th>
                            <th aria-label="transaction-amount-column">
                              {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.AMOUNT' | translate }}
                            </th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-transaction>
                          <tr>
                            <td>
                              @if (!transaction.commProcessedId) {
                                <p-checkbox [binary]="true"
                                  [ngModel]="isTransactionSelected(staff.staff_id, transaction)"
                                  (ngModelChange)="onTransactionSelect(staff.staff_id, transaction, $event)"
                                  [attr.aria-label]="'select-transaction-' + transaction.id" />
                              }
                            </td>
                            <td>{{ transaction.date | datetimeformat }}</td>
                            <td>
                              <span class="font-semibold">{{ transaction.plan_name || '-' }}</span>
                            </td>
                            <td>{{ transaction.slab_name || '-' }}</td>
                            <td>
                              <p-tag [value]="'COMMISSION_MANAGEMENT.TRANSACTIONS.' + transaction.mode | translate"
                                [severity]="'success'"
                                [attr.aria-label]="'transaction-type-' + transaction.mode" />
                            </td>
                            <td>
                              <span class="font-semibold">{{ transaction.amount | currencyformat }}</span>
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td colspan="7" class="text-center py-4">
                              <i class="pi pi-info-circle text-400 text-2xl mb-2"></i>
                              <p class="text-500 m-0">
                                {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.NO_TRANSACTIONS' | translate }}
                              </p>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                      </div>
                    } @else {
                      <div class="text-center py-4">
                        <i class="pi pi-info-circle text-400 text-3xl mb-3"></i>
                        <p class="text-600 font-semibold mb-2">
                          {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.NO_TRANSACTIONS' | translate }}
                        </p>
                      </div>
                    }
                  </div>
                </td>
              </tr>
            </ng-template>

            <!-- Empty State -->
            <ng-template #emptymessage>
              <tr>
                <td colspan="8" class="text-center py-5">
                  <i class="pi pi-inbox text-400 text-5xl mb-3"></i>
                  <p class="text-600 font-semibold text-lg mb-2">
                    {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.NO_STAFF' | translate }}
                  </p>
                  <p class="text-500 m-0">
                    {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.NO_STAFF_DESC' | translate }}
                  </p>
                </td>
              </tr>
            </ng-template>
          </p-table>
          </div>
          </div>
        }

        <!-- Processed Tab Content -->
        @if (activeTabIndex === 1) {
          <div>
          <div class="flex flex-column md:flex-row justify-content-between md:align-items-center gap-3 mb-3 mt-3">
            <div>
              <p class="text-500 mt-0 mb-0">
                {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.PROCESSED_SUBTITLE' | translate }}
              </p>
            </div>
            <div class="flex flex-wrap gap-2">
              <p-button [label]="'COMMISSION_MANAGEMENT.TRANSACTIONS.EXPAND_ALL' | translate"
                icon="pi pi-plus"
                [text]="true"
                size="small"
                styleClass="white-space-nowrap"
                (onClick)="expandAll()"
                aria-label="expand-all-rows-button" />
              <p-button [label]="'COMMISSION_MANAGEMENT.TRANSACTIONS.COLLAPSE_ALL' | translate"
                icon="pi pi-minus"
                [text]="true"
                size="small"
                styleClass="white-space-nowrap"
                (onClick)="collapseAll()"
                aria-label="collapse-all-rows-button" />
            </div>
          </div>

          <!-- Staff Table (Processed) -->
          <div class="overflow-x-auto">
            <p-table
              [value]="processedStaffList"
              [loading]="loading"
              [paginator]="true"
              [rows]="pageSize"
              [totalRecords]="totalRecords"
              [lazy]="true"
              (onPage)="onPageChange($event)"
              [rowsPerPageOptions]="[10, 25, 50]"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="{first} - {last} of {totalRecords}"
              dataKey="staff_id"
              [expandedRowKeys]="expandedRows"
              (onRowExpand)="onRowExpand($event)"
              (onRowCollapse)="onRowCollapse($event)"
              styleClass="p-datatable-gridlines"
              [tableStyle]="{ 'min-width': '60rem' }"
              [responsiveLayout]="'scroll'"
              aria-label="processed-transactions-table">
            
            <ng-template #header>
              <tr>
                <th style="width: 3rem" aria-label="expand-column"></th>
                <th aria-label="staff-name-column">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.STAFF_NAME' | translate }}
                </th>
                <th aria-label="staff-email-column">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.EMAIL' | translate }}
                </th>
                <th aria-label="staff-mobile-column">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.MOBILE' | translate }}
                </th>
                <th aria-label="transaction-type-column">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.TYPE' | translate }}
                </th>
                <th aria-label="aggregated-amount-column">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.AMOUNT' | translate }}
                </th>
                <th aria-label="transactions-count-column">
                  {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.TRANSACTIONS_COUNT' | translate }}
                </th>
              </tr>
            </ng-template>

            <ng-template #body let-staff let-expanded="expanded">
              <tr>
                <td>
                  <p-button type="button"
                    [pRowToggler]="staff"
                    [text]="true"
                    [rounded]="true"
                    [plain]="true"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    [attr.aria-label]="'expand-row-' + staff.staff_id" />
                </td>
                <td>
                  <span class="font-semibold">{{ staff.staff_name }}</span>
                </td>
                <td>{{ staff.staff_email_id }}</td>
                <td>{{ staff.staff_mobile }}</td>
                <td>
                  <p-tag [value]="staff.type"
                    [severity]="getTransactionTypeSeverity(staff.type)"
                    [attr.aria-label]="'transaction-type-' + staff.type" />
                </td>
                <td>
                  <span class="font-semibold">{{ staff.aggregated_amount | currencyformat }}</span>
                </td>
                <td>
                  <p-tag [value]="getTransactionsCount(staff)"
                    severity="success"
                    [attr.aria-label]="'transactions-count-' + staff.staff_id" />
                </td>
              </tr>
            </ng-template>

            <!-- Row Expansion Template -->
            <ng-template #expandedrow let-staff>
              <tr>
                <td colspan="7">
                  <div class="p-3">
                    @if (hasTransactions(staff)) {
                      <div>
                      <h5 class="text-900 font-semibold mb-3">
                        {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.TRANSACTION_DETAILS' | translate }}
                      </h5>
                      
                      <!-- Transactions Table -->
                      <p-table
                        [value]="staff.transactions"
                        styleClass="p-datatable-sm"
                        [tableStyle]="{ 'min-width': '50rem' }"
                        aria-label="staff-processed-transactions-table">
                        <ng-template pTemplate="header">
                          <tr>
                            <th aria-label="transaction-date-column">
                              {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.DATE' | translate }}
                            </th>
                            <th aria-label="transaction-plan-column">
                              {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.PLAN' | translate }}
                            </th>
                            <th aria-label="transaction-slab-column">
                              {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.SLAB' | translate }}
                            </th>
                            <th aria-label="transaction-type-column">
                              {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.TYPE' | translate }}
                            </th>
                            <th aria-label="transaction-amount-column">
                              {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.AMOUNT' | translate }}
                            </th>
                            <th aria-label="transaction-notes-column">
                              {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.NOTES' | translate }}
                            </th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-transaction>
                          <tr>
                            <td>{{ transaction.date | datetimeformat }}</td>
                            <td>
                              <span class="font-semibold">{{ transaction.plan_name || '-' }}</span>
                            </td>
                            <td>{{ transaction.slab_name || '-' }}</td>
                            <td>
                              <p-tag [value]="transaction.type_name"
                                [severity]="getTransactionTypeSeverity(transaction.type_name)"
                                [attr.aria-label]="'transaction-type-' + transaction.type_name" />
                            </td>
                            <td>
                              <span class="font-semibold">{{ transaction.amount | currencyformat }}</span>
                            </td>
                            <td>{{ transaction.notes || '-' }}</td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td colspan="6" class="text-center py-4">
                              <i class="pi pi-info-circle text-400 text-2xl mb-2"></i>
                              <p class="text-500 m-0">
                                {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.NO_TRANSACTIONS' | translate }}
                              </p>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                      </div>
                    } @else {
                      <div class="text-center py-4">
                        <i class="pi pi-info-circle text-400 text-3xl mb-3"></i>
                        <p class="text-600 font-semibold mb-2">
                          {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.NO_TRANSACTIONS' | translate }}
                        </p>
                      </div>
                    }
                  </div>
                </td>
              </tr>
            </ng-template>

            <!-- Empty State -->
            <ng-template #emptymessage>
              <tr>
                <td colspan="7" class="text-center py-5">
                  <i class="pi pi-inbox text-400 text-5xl mb-3"></i>
                  <p class="text-600 font-semibold text-lg mb-2">
                    {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.NO_PROCESSED_STAFF' | translate }}
                  </p>
                  <p class="text-500 m-0">
                    {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.NO_PROCESSED_STAFF_DESC' | translate }}
                  </p>
                </td>
              </tr>
            </ng-template>
          </p-table>
          </div>
          </div>
        }
    </div>
  </div>
</div>

<!-- Staff Adjustment Dialog -->
<p-dialog
  [visible]="showStaffAdjustmentDialog"
  [header]="'COMMISSION_MANAGEMENT.TRANSACTIONS.STAFF_ADJUSTMENT_DIALOG_TITLE' | translate"
  [modal]="true"
  [style]="{ width: '500px' }"
  [draggable]="false"
  [resizable]="false"
  aria-label="staff-adjustment-dialog">
  
  <div class="flex flex-column gap-3">
    <div>
      <label class="font-semibold text-900 mb-2 block">
        {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.SELECT_STAFF' | translate }}
        <sup class="text-red-500">*</sup>
      </label>
      <multi-select-staff [selected]="selectedStaffIdsForAdjustment"
        [placeholder]="'COMMISSION_MANAGEMENT.TRANSACTIONS.SELECT_STAFF_PLACEHOLDER' | translate"
        (selectStaffEvent)="onAdjustmentStaffChanged($event)" />
    </div>

    <div>
      <label for="staff-adjustment-date" class="font-semibold text-900 mb-2 block">
        {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.ADJUSTMENT_DATE' | translate }}
        <sup class="text-red-500">*</sup>
      </label>
      <p-datepicker id="staff-adjustment-date"
        [(ngModel)]="staffAdjustmentDate"
        [showIcon]="true"
        [showButtonBar]="true"
        dateFormat="yy-mm-dd"
        [placeholder]="'COMMISSION_MANAGEMENT.TRANSACTIONS.SELECT_DATE' | translate"
        styleClass="w-full"
        aria-label="staff-adjustment-date-input" />
    </div>

    <div>
      <label for="staff-adjustment-amount" class="font-semibold text-900 mb-2 block">
        {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.ADJUSTMENT_AMOUNT' | translate }}
        <sup class="text-red-500">*</sup>
      </label>
      <p-inputNumber id="staff-adjustment-amount"
        [(ngModel)]="staffAdjustmentAmount"
        mode="currency"
        [currency]="currencyCode"
        [locale]="locale"
        [minFractionDigits]="2"
        [maxFractionDigits]="2"
        [placeholder]="'COMMISSION_MANAGEMENT.TRANSACTIONS.AMOUNT_PLACEHOLDER' | translate"
        styleClass="w-full"
        inputStyleClass="w-full"
        aria-label="staff-adjustment-amount-input" />
    </div>

    <div>
      <label for="staff-adjustment-notes" class="font-semibold text-900 mb-2 block">
        {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.NOTES' | translate }}
        <sup class="text-red-500">*</sup>
      </label>
      <textarea
        id="staff-adjustment-notes"
        pTextarea
        [(ngModel)]="staffAdjustmentNotes"
        [rows]="5"
        [autoResize]="true"
        [placeholder]="'COMMISSION_MANAGEMENT.TRANSACTIONS.NOTES_PLACEHOLDER' | translate"
        class="w-full"
        aria-label="staff-adjustment-notes-input">
      </textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button [label]="'COMMISSION_MANAGEMENT.COMMON.CANCEL' | translate"
      icon="pi pi-times"
      [outlined]="true"
      severity="secondary"
      (onClick)="closeStaffAdjustmentDialog()"
      aria-label="cancel-staff-adjustment-button" />
    <p-button [label]="'COMMISSION_MANAGEMENT.COMMON.SUBMIT' | translate"
      icon="pi pi-check"
      [loading]="processingStaffAdjustment"
      [disabled]="selectedStaffForAdjustment.length === 0 || !staffAdjustmentDate || !staffAdjustmentNotes.trim() || !staffAdjustmentAmount || staffAdjustmentAmount <= 0"
      (onClick)="submitStaffAdjustment()"
      aria-label="submit-staff-adjustment-button" />
  </ng-template>
</p-dialog>

<!-- Bulk Transaction Process Dialog -->
<p-dialog
  [visible]="showBulkTransactionProcessDialog"
  [header]="'COMMISSION_MANAGEMENT.TRANSACTIONS.BULK_PROCESS_DIALOG_TITLE' | translate"
  [modal]="true"
  [style]="{ width: '500px' }"
  [draggable]="false"
  [resizable]="false"
  aria-label="bulk-transaction-process-dialog">
  
  <div class="flex flex-column gap-3">
    <div>
      <p class="text-600 mb-2">
        {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.SELECTED_TRANSACTIONS_COUNT' | translate: {count: totalSelectedTransactions} }}
      </p>
    </div>

    <div>
      <label for="bulk-transaction-process-notes" class="font-semibold text-900 mb-2 block">
        {{ 'COMMISSION_MANAGEMENT.TRANSACTIONS.NOTES' | translate }}
        <sup class="text-red-500">*</sup>
      </label>
      <textarea
        id="bulk-transaction-process-notes"
        pTextarea
        [(ngModel)]="bulkTransactionProcessNotes"
        [rows]="5"
        [autoResize]="true"
        [placeholder]="'COMMISSION_MANAGEMENT.TRANSACTIONS.NOTES_PLACEHOLDER' | translate"
        class="w-full"
        aria-label="bulk-transaction-process-notes-input">
      </textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button [label]="'COMMISSION_MANAGEMENT.COMMON.CANCEL' | translate"
      icon="pi pi-times"
      [outlined]="true"
      severity="secondary"
      (onClick)="closeBulkTransactionProcessDialog()"
      aria-label="cancel-bulk-transaction-process-button" />
    <p-button [label]="'COMMISSION_MANAGEMENT.COMMON.SUBMIT' | translate"
      icon="pi pi-check"
      [loading]="processingBulkTransactions"
      [disabled]="!bulkTransactionProcessNotes.trim()"
      (onClick)="submitBulkTransactionProcess()"
      aria-label="submit-bulk-transaction-process-button" />
  </ng-template>
</p-dialog>

<p-toast />

